/**
 * Attaky Cart Page Interactions
 * Handles quantity changes, item removal, per-item notes, and order notes
 * through storefront cart endpoints
 */
(function() {
  'use strict';

  function initCart() {
    // Quantity minus buttons
    document.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-key');
        var current = parseInt(btn.getAttribute('data-current') || '1');
        var newQty = current - 1;
        if (newQty <= 0) {
          removeItem(key);
        } else {
          updateQuantity(key, newQty);
        }
      });
    });

    // Quantity plus buttons
    document.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-key');
        var current = parseInt(btn.getAttribute('data-current') || '1');
        updateQuantity(key, current + 1);
      });
    });

    // Remove buttons
    document.querySelectorAll('[data-remove-item]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-key');
        removeItem(key);
      });
    });

    // Discount form
    var discountForm = document.getElementById('discount-form');
    if (discountForm) {
      discountForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var input = document.getElementById('discount-input');
        var code = input ? input.value.trim() : '';
        if (code) {
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
        }
      });
    }

    // Notes management
    initNotes();
  }

  // ======================== Quantity / Remove ========================

  function updateQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(response) { return response.json(); })
    .then(function() {
      window.location.reload();
    })
    .catch(function() {});
  }

  function removeItem(key) {
    updateQuantity(key, 0);
  }

  // ======================== Notes Management ========================

  // Update a per-item note by removing and re-adding the item.
  // Fetches authoritative cart data from /cart.js first (avoids DOM parsing issues).
  // The quantity endpoint does not support updating line-item properties,
  // so we must remove the item and re-add it with the new properties.
  function saveItemNote(key, newNote) {
    // Step 0: Fetch current cart data
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        // Find the target item
        var item = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) {
            item = cart.items[i];
            break;
          }
        }
        if (!item) return;

        var variantId = item.variant_id;
        var qty = item.quantity;

        // Clone original properties safely
        var originalProps = {};
        if (item.properties && typeof item.properties === 'object') {
          for (var k in item.properties) {
            if (item.properties.hasOwnProperty(k)) {
              originalProps[k] = item.properties[k];
            }
          }
        }

        // Build updated properties
        var updatedProps = {};
        for (var k in originalProps) {
          if (originalProps.hasOwnProperty(k)) updatedProps[k] = originalProps[k];
        }
        if (newNote && newNote.trim()) {
          updatedProps.Note = newNote.trim();
        } else {
          delete updatedProps.Note;
        }

        // Helper: add item back to cart
        function addBack(props) {
          var body = {
            items: [{
              id: variantId,
              quantity: qty,
              properties: props
            }]
          };
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          }).then(function(res) {
            return res.json().then(function(data) {
              if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
              return data;
            });
          });
        }

        // Step 1: Remove the item
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          // Step 2: Re-add with updated properties
          return addBack(updatedProps);
        })
        .then(function() {
          window.location.reload();
        })
        .catch(function() {
          // Recovery: try to re-add with original properties so the item isn't lost
          addBack(originalProps)
            .then(function() {
              window.location.reload();
            })
            .catch(function() {
              window.location.reload();
            });
        });
      })
      .catch(function() {});
  }

  // Delete a per-item note
  function deleteItemNote(key) {
    saveItemNote(key, '');
  }

  // Save the order-level note via /cart/update.js
  function saveOrderNote(note) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note || '' })
    })
    .then(function(res) { return res.json(); })
    .then(function() { window.location.reload(); })
    .catch(function() {});
  }

  // Delete the order-level note
  function deleteOrderNote() {
    saveOrderNote('');
  }

  function initNotes() {
    // --- Add Note: show/hide form ---
    var addBtn = document.getElementById('notes-add-btn');
    var addForm = document.getElementById('notes-add-form');
    var addSave = document.getElementById('notes-add-save');
    var addCancel = document.getElementById('notes-add-cancel');
    var addTarget = document.getElementById('notes-add-target');
    var addText = document.getElementById('notes-add-text');
    var emptyMsg = document.getElementById('notes-empty');

    if (addBtn && addForm) {
      addBtn.addEventListener('click', function() {
        addBtn.style.display = 'none';
        addForm.style.display = '';
        if (emptyMsg) emptyMsg.style.display = 'none';
        if (addText) addText.focus();
      });
    }

    if (addCancel && addForm) {
      addCancel.addEventListener('click', function() {
        addForm.style.display = 'none';
        if (addBtn) addBtn.style.display = '';
        if (addText) addText.value = '';
        // Restore empty msg if no notes exist
        if (emptyMsg && document.querySelectorAll('[data-note-card]').length === 0) {
          emptyMsg.style.display = '';
        }
      });
    }

    if (addSave) {
      addSave.addEventListener('click', function() {
        var text = addText ? addText.value.trim() : '';
        if (!text) return;
        var target = addTarget ? addTarget.value : 'order';
        if (target === 'order') {
          saveOrderNote(text);
        } else {
          saveItemNote(target, text);
        }
      });
    }

    // --- Per-card: Edit / Delete ---
    document.querySelectorAll('[data-note-card]').forEach(function(card) {
      var type = card.getAttribute('data-note-type');
      var key = card.getAttribute('data-note-key');
      var displayEl = card.querySelector('[data-note-display]');
      var editFormEl = card.querySelector('[data-note-edit-form]');
      var editTextarea = card.querySelector('[data-note-edit-textarea]');

      // Edit button
      var editBtn = card.querySelector('[data-note-edit-btn]');
      if (editBtn) {
        editBtn.addEventListener('click', function() {
          if (displayEl) displayEl.style.display = 'none';
          if (editFormEl) {
            editFormEl.style.display = '';
            if (editTextarea) editTextarea.focus();
          }
        });
      }

      // Edit cancel
      var editCancel = card.querySelector('[data-note-edit-cancel]');
      if (editCancel) {
        editCancel.addEventListener('click', function() {
          if (editFormEl) editFormEl.style.display = 'none';
          if (displayEl) displayEl.style.display = '';
        });
      }

      // Edit save
      var editSave = card.querySelector('[data-note-edit-save]');
      if (editSave) {
        editSave.addEventListener('click', function() {
          var newText = editTextarea ? editTextarea.value.trim() : '';
          if (!newText) return;
          if (type === 'order') {
            saveOrderNote(newText);
          } else {
            saveItemNote(key, newText);
          }
        });
      }

      // Delete button
      var deleteBtn = card.querySelector('[data-note-delete-btn]');
      if (deleteBtn) {
        deleteBtn.addEventListener('click', function() {
          if (type === 'order') {
            deleteOrderNote();
          } else {
            deleteItemNote(key);
          }
        });
      }
    });
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCart);
  } else {
    initCart();
  }
})();
